import * as _4 from 'lodash4';
import { AdvisorBlockedSuggestionsQuery } from '../blocked_suggestions/queries/blocked_suggestions_query';
import { AdvisorSentFeedbackDiffQuery } from './queries/advisor_sent_feedback_diff_query';
import { APAdvisorSentFeedbackTermsQuery } from './queries/advisor_sent_feedback_terms_query';
class PlanFeedback {
  private commentOnly: boolean;
  private advisorLabel: string = 'advisor';
  private openDialog: boolean = true;
  private showConflictAlert = false;
  constructor(
    private ngAPAdvisorSentFeedbackDiffQuery: AdvisorSentFeedbackDiffQuery,
    private ngAPAdvisorSentFeedbackTermsQuery: APAdvisorSentFeedbackTermsQuery,
    private ngAPAdvisorBlockedSuggestionsQuery: AdvisorBlockedSuggestionsQuery,
    private appConfigModel: any
  ) {}

  $onInit() {
    this.advisorLabel = _4.get(this.appConfigModel, 'model.member_configs.advisor_label', 'advisor');
    this.commentOnly =
      _4.sumBy(this.ngAPAdvisorSentFeedbackDiffQuery.result.termsAndSuggestions, 'suggestions.length') === 0;
    this.showConflictAlert = !_4.isEmpty(this.ngAPAdvisorBlockedSuggestionsQuery.result.conflictingSuggestions);
  }

  closeDialog() {
    this.openDialog = false;
  }
}

angular.module('capability-ng-academic-planner').component('planFeedback', {
  templateUrl: 'capability-ng-academic-planner/src/suggestions/components/plan_feedback/plan_feedback.html',
  controller: PlanFeedback
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/suggestions/components/plan_feedback/plan_feedback.ts